import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export function AnimatedButtonWrapper({
  children,
  isVisible,
}: {
  isVisible: boolean;
  children: React.ReactNode;
}) {
  const [atBottom, setAtBottom] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkBottom = () => {
      const current = containerRef.current;
      if (current === null) {
        return;
      }

      const container = current.parentElement;
      if (container === null) {
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const buttonRect = current.getBoundingClientRect();

      setAtBottom(buttonRect.bottom >= containerRect.bottom - 1);
    };

    checkBottom();
    window.addEventListener("resize", checkBottom);
    window.addEventListener("scroll", checkBottom);

    return () => {
      window.removeEventListener("resize", checkBottom);
      window.removeEventListener("scroll", checkBottom);
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          ref={containerRef}
          key="button-wrapper"
          exit={{ height: 0, opacity: 0 }}
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className="pointer-events-none sticky bottom-0 z-10 flex w-full justify-end py-4"
        >
          <motion.div
            className="pointer-events-auto"
            transition={{ duration: 0.3 }}
            animate={{
              filter:
                atBottom ?
                  "drop-shadow(0 0 0 rgba(0,0,0,0))"
                : "drop-shadow(2px 2px 3px rgba(0,0,0,0.5))",
            }}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
